/* eslint-disable complexity */
import { status } from '../constants';

export const getMultiSelectFieldStatus = (meta, value) => {
  const {
    visited,
    active,
    error,
    submitError,
    dirtySinceLastSubmit,
    submitFailed,
    touched,
  } = meta;
  if (
    (Boolean((value && value.length > 0) || (touched && !active) || visited)
      && !active
      && Boolean(error))
    || (Boolean(submitError) && !dirtySinceLastSubmit)
    || (submitFailed && error)
  ) {
    return status.ERROR;
  }
  return status.DEFAULT;
};

export const getFieldStatus = (meta, value) => {
  const {
    visited,
    active,
    error,
    submitError,
    dirtySinceLastSubmit,
    submitFailed,
    touched,
  } = meta;
  if (
    ((value || visited || (touched && !active)) && !active && error)
    || (submitError && !dirtySinceLastSubmit)
    || (submitFailed && error)
  ) {
    return status.ERROR;
  }
  return status.DEFAULT;
};

export const getFieldErrorMessage = (meta, fieldStatus) => (fieldStatus === status.ERROR ? meta.error || meta.submitError : '');
